var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgViewAll = function SvgViewAll(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 23C13 23.2761 12.7761 23.5 12.5 23.5H11.5C11.2239 23.5 11 23.2761 11 23V2C11 1.72386 11.2239 1.5 11.5 1.5H12.5C12.7761 1.5 13 1.72386 13 2V23ZM9 20C9 19.7239 8.77614 19.5 8.5 19.5H5V5.5H8.5C8.77614 5.5 9 5.27614 9 5V4C9 3.72386 8.77614 3.5 8.5 3.5H5C3.89 3.5 3 4.39 3 5.5V19.5C3 20.61 3.9 21.5 5 21.5H8.5C8.77614 21.5 9 21.2761 9 21V20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.5H15.5C15.2239 19.5 15 19.7239 15 20V21C15 21.2761 15.2239 21.5 15.5 21.5H19C20.1 21.5 21 20.61 21 19.5V5.5C21 4.39 20.11 3.5 19 3.5H15.5C15.2239 3.5 15 3.72386 15 4V5C15 5.27614 15.2239 5.5 15.5 5.5H19V19.5Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgViewAll);
export { ForwardRef as ReactComponent };